import { IEvent } from "@Interfaces";
import { chainShortCircuits, EVENT_TYPE } from "@Utils";

export const getIsTicketingEnabled = ({
    event,
    eventData,
    isRebooking,
}: {
    event: IEvent.IStore;
    eventData: IEvent.IEventData;
    isRebooking: boolean;
}) => {
    const disableMultipleUserBooking =
        eventData.metadata?.disable_multiple_user_booking;
    if (disableMultipleUserBooking) return false;

    const eventType = eventData.type;

    const { appliedDiscountCodeType } = event.discount;

    // Whether to show the multiple user booking counter or not
    return chainShortCircuits<boolean>(
        [
            [appliedDiscountCodeType === "loyalty", false],
            [isRebooking, false],
            [eventType === EVENT_TYPE.TELEGRAM, false],
            [
                [
                    EVENT_TYPE.APPOINTMENTS,
                    EVENT_TYPE.WEBINAR,
                    EVENT_TYPE.ONE_ON_ONE_CLASSES,
                ].includes(eventType),
                eventData?.max_spots > 1,
            ],
            [
                [EVENT_TYPE.WORKSHOPS].includes(eventType),
                eventData?.slots?.length > 0 &&
                    eventData?.max_spots > eventData?.slots?.[0]?.spots_filled,
            ],
            [
                [EVENT_TYPE.MERCHANDISE, EVENT_TYPE.RECORDED_CONTENT].includes(
                    eventType
                ),
                false,
            ],
        ],
        true
    );
};
